module.exports = __webpack_public_path__ + "img/capital-motors.abd04566.png";